import React from 'react';

import Reveal from '../ui/Reveal';

const SCOPES = [
    { id: 'DC', title: 'UPS DC bus and data quality' },
    { id: 'AC', title: 'AC distribution' }
];

function Group({ group }) {
    return (
        <details className="catalog__group" id={`measure-${group.id}`}>
            <summary className="catalog__summary">
                <span className="catalog__name">{group.title}</span>
                <span className="catalog__blurb">{group.blurb}</span>
                <span className="catalog__count">{group.items.length}</span>
                <span className="catalog__sign" aria-hidden="true" />
            </summary>

            <ul className="catalog__rows">
                {group.items.map(item => (
                    <li className="catalog__row" key={item.id}>
                        <div>
                            <h4 className="catalog__measure">{item.name}</h4>
                            <p className="catalog__unit">{item.id} · {item.unit}</p>
                            <span className={`catalog__type catalog__type--${item.type.toLowerCase()}`}>{item.type}</span>
                        </div>

                        <div>
                            <p className="catalog__definition">{item.definition}</p>
                            <p className="catalog__meta">
                                <span>Instrument: {item.source}</span>
                                <span>Cadence: {item.target}</span>
                            </p>
                        </div>
                    </li>
                ))}
            </ul>
        </details>
    );
}

/**
 * The whole measurement list, a group to a row. <details> rather than the
 * Faqs accordion: closed, a group is still in the document, so the reference
 * stays searchable with the browser's find and readable to a crawler, and
 * there are ninety-nine of them to find.
 */
export default function MeasurementCatalog({ groups }) {
    return (
        <div className="catalog">
            {SCOPES.map(scope => (
                <Reveal key={scope.id} y={22} amount={0.05}>
                    <h3 className="catalog__scope">{scope.title}</h3>

                    {groups
                        .filter(group => group.scope === scope.id)
                        .map(group => <Group group={group} key={group.id} />)}
                </Reveal>
            ))}
        </div>
    );
}
